import { useEffect, useState } from 'react';
import Bowser from 'bowser';
import Modal from '../Modal';

export default function UnsupportedBrowserWarning() {
  const [blocked, setBlocked] = useState(false);

  useEffect(() => {
    const browser = Bowser.getParser(window.navigator.userAgent);
    const isValidBrowser = browser.satisfies({
      chrome: '>130.0.6723.69',
      edge: '>130.0.2849.68',
      firefox: '>131.0',
      safari: '>=18.1'
    });

    setBlocked(!isValidBrowser);
  }, []);

  return (
    <Modal
      visible={blocked}
      header="Din webbläsare stöds inte"
      onClose={() => setBlocked(false)}
      onActionCompleted={() => setBlocked(false)}
      actionI18nKey="global.buttons.ok"
      actionCompletable
    >
      <p>Admin fungerar bäst med någon av följande webbläsare.</p>
      <ul className="disc-list">
        <li>Google Chrome: 130.0.6723.69</li>
        <li>Microsoft Edge: 130.0.2849.68</li>
        <li>Mozilla Firefox: 131.0</li>
        <li>Apple Safari: 18.1</li>
      </ul>
      <p>Vänligen uppdatera din webbläsare, eller byt till någon av de som listas ovan.</p>
    </Modal>
  );
}
